<div class="mat-card">
  <h3>{{ data.title }}</h3>
  <div>
    <p> {{ data.message }}</p>
  </div>
  <div class="actions">
    <ng-container *ngIf="data.dangerMode, else regularMode">
      <button mat-raised-button color="primary" [mat-dialog-close] cdkFocusInitial>{{ data.abortText || 'CANCEL' }}</button>
      <button mat-stroked-button class="dangerous-action-button" [mat-dialog-close]="'ok'">{{ data.proceedText }}</button>
    </ng-container>
    <ng-template #regularMode>
      <button mat-button [mat-dialog-close] color="primary" cdkFocusInitial>{{ data.abortText || 'CANCEL' }}</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="'ok'">{{ data.proceedText }}</button>
    </ng-template>
  </div>
</div>